import GoogleTagManager from '@redux-beacon/google-tag-manager'
import { eventsMap } from 'analytics/eventsMap'
import { routerMiddleware } from 'connected-react-router'
import userMiddleware from 'middlewares/userMiddleware'
import { createMiddleware } from 'redux-beacon'
import buildStore from './store'
import { analyticsListenerMiddleware } from 'middlewares/analyticsMiddleware'
import analyticsPageViewMiddleware from 'middlewares/analyticsPageViewMiddleware'
import { offerComparisonPersistenceMiddleware } from 'middlewares/offerComparisonPersistenceMiddleware'
import promoReapplicationMiddleware from 'middlewares/promoReapplicationMiddleware'
import merchandiseShippingCacheMiddleware from 'middlewares/merchandiseShippingCacheMiddleware'
import { historicalActionsPersistenceMiddleware } from 'middlewares/historicalActionsPersistenceMiddleware'
import actionRecorderMiddleware from 'middlewares/actionRecorderMiddleware'

function initialiseStore(history: any, initialState: App.State) {
  const googleTagManagerMiddleware = createMiddleware(
    eventsMap,
    GoogleTagManager(),
  )

  const middlewares = [
    userMiddleware,
    routerMiddleware(history),
    googleTagManagerMiddleware,
    analyticsListenerMiddleware.middleware,
    analyticsPageViewMiddleware.middleware,
    offerComparisonPersistenceMiddleware.middleware,
    historicalActionsPersistenceMiddleware.middleware,
    promoReapplicationMiddleware.middleware,
    merchandiseShippingCacheMiddleware,
    actionRecorderMiddleware,
  ]

  const store = buildStore(
    history,
    initialState,
    middlewares,
  )

  return store
}

export default initialiseStore
